import AlertSecondaryIcon from '@/images/AlertSecondaryIcon.svg?react';
import { ModalWindow } from '@/components/ModalWindow/ModalWindow';
import { Box } from '@/components/Box/Box';
import { Button } from '@/components/Button/Button';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import { Notification } from '@/components/Notification/Notification';

type CheckoutErrorModalType = {
  isOpen: boolean;
  errorMessage: string;
  onClose: () => void;
};

export const CheckoutErrorModal = ({ isOpen, errorMessage, onClose }: CheckoutErrorModalType) => {
  return (
    <ModalWindow isOpen={isOpen} isStartPositionHeader width='504px'>
      <Box display='flex' flexDirection='column' rowGap='28px'>
        <Box display='flex' flexDirection='column' rowGap='20px' alignItems='center'>
          <AlertSecondaryIcon />
          <Box width='100%' display='flex' flexDirection='column' alignItems='center' rowGap='12px'>
            <Typography variant='headline4' color={COLORS.grey[950]} fontWeight='semibold'>
              Payment Failed
            </Typography>
            <Typography color={COLORS.grey[950]} textAlign='center'>
              Something went wrong while processing your payment. Please try again or use a different payment method.
            </Typography>
            <Box width='100%'>
              <Notification variant='error'>{errorMessage}</Notification>
            </Box>
          </Box>
        </Box>
        <Button onClick={onClose}>Back</Button>
      </Box>
    </ModalWindow>
  );
};
